module.exports = __webpack_public_path__ + "static/media/ic_tools.a9cd9063.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/ic_tools.svg
// module id = 301
// module chunks = 0